import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";
import { Link } from "@reach/router";

function Ant(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "WE ARE ANTS! It is well known that we're exceptionally strong and
            fast. Although estimates vary, your average ant can carry between 10
            and 50 times our own body weight, and run at approximately 300
            meters an hour, a rate of nearly 800 times my body length a minute!
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Want to know something else that makes us amazing?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Some people say that an ant colony like mine, with all of us doing
            our different jobs, foraging, and building and defending and looking
            after the larvae, is like one giant super organism or one giant
            brain! I might not seem the smartest creature on the planet, but
            we're a lot better at making decisions and getting things done than
            you humans are, and
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              Do you know what?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            No one is in charge! That queen ant is just a figurehead, she
            doesn't tell me to do nothing. I tell you what, maybe you should ask
            us what to do next time you have a big pandemic or a climate
            emergency, we could teach you a thing or two about looking after
            each other. Oh, hang on, there is a really nice smelling trail over
            there, left by one of my mates telling where to find some food, see
            you later!
          </p>
        </div>
      </div>
    );
  }
}

export default Ant;
